<template>
	<div class="voucher-basket-container" 
		:style="{ backgroundColor: containerBackgroundColor }" 
		:class="{ 'clickable': voucherCount > 0 }"
		@click="handleClick">
		<div class="left-section">
			<div class="basket-container" :class="{ 'single-voucher': voucherCount === 1 }">
				<img :src="voucherCount > 1 ? require('@/assets/basket.svg') : icon" class="basket-icon" :class="{ 'single-voucher': voucherCount === 1 }" alt="Voucher Basket" />
				<div class="notification-badge" v-if="voucherCount > 1">
					<span class="badge-text">{{ voucherCount }}</span>
				</div>
			</div>
			<div class="text-section">
				<span class="basket-text">{{ basketText }}</span>
			</div>
		</div>
		<div class="right-section">
			<div class="amount-section">
				<span class="amount-text">{{ formattedTotal }}</span>
			</div>
			<img v-if="voucherCount > 0" src="@/assets/arrow-right.png" class="arrow-icon" alt="View basket" />
		</div>
	</div>
</template>

<script>
export default {
	name: "VoucherBasket",
	props: {
		voucherCount: {
			type: Number,
			default: 1
		},
		totalAmount: {
			type: Number,
			default: 100.00
		},
		basketText: {
			type: String,
			default: "View your basket"
		},
		colour: {
			type: String,
			default: "#E0EBE3"
		},
		icon: {
			type: String,
			default: "@/assets/basket.svg"
		}
	},
	emits: ['click'],
	computed: {
		formattedTotal() {
			return `£${this.totalAmount.toFixed(2)}`;
		},
		containerBackgroundColor() {
			if (this.voucherCount === 0) {
				return '#F0EEEA';
			} else if (this.voucherCount > 1) {
				return '#E0EBE3';
			} else {
				return this.colour;
			}
		}
	},
	methods: {
		onLoad() {
			// Component initialization logic here
		},
		handleClick() {
			if (this.voucherCount > 0) {
				this.$emit('click');
			}
		}
	},
	mounted() {
		this.onLoad();
	}
}
</script>

<style scoped>
.voucher-basket-container {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 16px;
	border-radius: 0 0 24px 24px;
	width: 100%;
	cursor: default;
	transition: opacity 0.2s ease;
}

.voucher-basket-container.clickable {
	cursor: pointer;
}

.voucher-basket-container.clickable:hover {
	opacity: 0.9;
}

.left-section {
	display: flex;
	align-items: center;
	gap: 8px;
}

.basket-container {
	position: relative;
	width: 32px;
	height: 32px;
}

.basket-container.single-voucher {
	width: 48px;
	height: 32px;
}

.basket-icon {
	width: 32px;
	height: 32px;
}

.basket-icon.single-voucher {
	width: 48px;
	height: 32px;
	border-radius: 8px;
	object-fit: cover;
}

.notification-badge {
	position: absolute;
	top: -4px;
	right: -4px;
	width: 18px;
	height: 18px;
	background-color: #23AF64;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.badge-text {
	color: white;
	font-family: 'Gotham', sans-serif;
	font-weight: 700;
	font-size: 10px;
	line-height: 1.1;
	text-align: center;
}

.text-section {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.basket-text {
	color: #413655;
	font-family: 'Gotham', sans-serif;
	font-weight: 500;
	font-size: 13px;
	line-height: 1.23;
}

.right-section {
	display: flex;
	align-items: center;
	gap: 8px;
}

.amount-section {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-end;
}

.amount-text {
	color: #413655;
	font-family: 'Gotham', sans-serif;
	font-weight: 500;
	font-size: 13px;
	line-height: 1.23;
}

.arrow-icon {
	width: 16px;
	height: 10px;
}

/* When used in specific contexts, allow max-width constraint */
.standalone .voucher-basket-container {
	max-width: 375px;
	margin: 0 auto;
}
</style>